module.exports = __webpack_public_path__ + "media/images/deliver-icon-246e7b88442e8c3db90cfa585bb7f9d3.svg";